import type { ErrorMessageKeys, ErrorScope } from '../types'

/* the title and text keys under aichat.main.errors per turn error code; the error's own `message` is never shown */
export const ERROR_MESSAGES: Readonly<Record<string, ErrorMessageKeys>> = {
  aborted: { title: 'stopped' },
  unauthorized: { title: 'generic', text: 'unauthorized' },
  unreachable: { title: 'generic', text: 'unreachable' },
  forbidden: { title: 'not_permitted', text: 'forbidden' },
  FEATURE_INACTIVE: { title: 'upsell_title', text: 'upsell_text' },
  CONVERSATION_NOT_FOUND: { title: 'generic', text: 'conversation_not_found' },
  validation: { title: 'generic', text: 'validation' },
  PLATFORM_RATE_LIMITED: { title: 'rate_limited', text: 'rate_limited_text' },
  PLATFORM_TOOLS_UNAVAILABLE: { title: 'generic', text: 'tools_unavailable' },
  PLATFORM_UNAVAILABLE: { title: 'generic', text: 'unavailable' },
  PLATFORM_TIMEOUT: { title: 'generic', text: 'timeout' },
  TURN_FAILED: { title: 'generic', text: 'turn_failed' },
  server_error: { title: 'generic', text: 'server_error' }
}

export const UNKNOWN_ERROR_MESSAGE: ErrorMessageKeys = {
  title: 'generic',
  text: 'turn_failed'
}

/* the text key under aichat.main.errors of an in-answer notice, by the error's scope */
export const NOTICE_MESSAGES: Readonly<
  Record<Exclude<ErrorScope, 'turn'>, string>
> = {
  tool_call: 'tool_call_notice',
  widget: 'widget_notice'
}
